import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { useCityServices } from './hooks/useCityServices';
import L from 'leaflet';
import Loading from '../../../Loading';
import { number } from '../../../Util/number';
import TableComponent from '../../../Charts/TableCharts';

const CityServices = ({ queryConfig }) => {
    const { chartData, isLoading } = useCityServices(queryConfig);

    if (isLoading) {
        return <Loading />;
    }

    const toCoordinate = (value) => (value ? Number(value) : NaN);
    const firstCity = chartData?.counterByCity?.find(
        (city) => city.latitude || city.nu_latitude
    );
    const cityLat = toCoordinate(firstCity?.latitude || firstCity?.nu_latitude);
    const cityLng = toCoordinate(firstCity?.longitude || firstCity?.nu_longitude);

    const center = !isNaN(cityLat) && !isNaN(cityLng)
        ? [cityLat, cityLng]
        : [-23.5489, -46.6388];

    const tableColumns = [
        {
            key: 'description',
            header: 'Unidade',
            headerStyle: { fontWeight: '500' },
            cellStyle: { fontWeight: '400' }
        },
        {
            key: 'total',
            header: 'Total de Atendimentos',
            headerStyle: { fontWeight: '500', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'percentage',
            header: '%',
            headerStyle: { fontWeight: '500', textAlign: 'right' },
            cellStyle: { textAlign: 'right', fontWeight: '400' },
            formatter: (value) => {
                const percentage = Number(value || 0);
                if (percentage > 0 && percentage < 0.01) {
                    return '< 0,01%';
                }

                return `${percentage.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}%`;
            }
        }
    ];

    const totalServices = chartData.counterByCity.reduce(
        (acc, city) => acc + Number(city.services || 0),
        0
    );

    const transformedData = chartData.counterByCity.map((city) => ({
        description: city.municipio || city.no_fantasia,
        total: city.services,
        percentage: totalServices
            ? (Number(city.services || 0) / totalServices) * 100
            : 0,
        latitude: toCoordinate(city.latitude || city.nu_latitude),
        longitude: toCoordinate(city.longitude || city.nu_longitude)
    }));

    const markerIcon = new L.Icon({
        iconUrl:
            'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png',
        shadowUrl:
            'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png',
        iconSize: [12, 24],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [12, 12]
    });

    return (
        <div className="mapa-container-dashboards">
            <MapContainer
                center={center}
                zoom={6}
                className="leaflet-container-dashboards"
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {transformedData.map((city, index) =>
                    !isNaN(city.latitude) && !isNaN(city.longitude) ? (
                        <Marker
                            key={index}
                            position={[city.latitude, city.longitude]}
                            icon={markerIcon}
                        >
                            <Popup>{city.description}</Popup>
                        </Marker>
                    ) : null
                )}
            </MapContainer>

            <TableComponent
                data={transformedData}
                columns={tableColumns}
                title="Atendimentos por Município"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};

export default CityServices;
